"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountExchangeStatus = void 0;
var AccountExchangeStatus;
(function (AccountExchangeStatus) {
    AccountExchangeStatus["CREATED"] = "CREATED";
    AccountExchangeStatus["FAILED"] = "FAILED";
    AccountExchangeStatus["FILLED"] = "FILLED";
    AccountExchangeStatus["DONE"] = "DONE";
})(AccountExchangeStatus = exports.AccountExchangeStatus || (exports.AccountExchangeStatus = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQWNjb3VudEV4Y2hhbmdlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL0FjY291bnRFeGNoYW5nZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxJQUFZLHFCQUtYO0FBTEQsV0FBWSxxQkFBcUI7SUFDL0IsNENBQW1CLENBQUE7SUFDbkIsMENBQWlCLENBQUE7SUFDakIsMENBQWlCLENBQUE7SUFDakIsc0NBQWEsQ0FBQTtBQUNmLENBQUMsRUFMVyxxQkFBcUIsR0FBckIsNkJBQXFCLEtBQXJCLDZCQUFxQixRQUtoQyJ9